import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Navbar } from 'react-bootstrap';
import Dropdown from 'react-bootstrap/Dropdown';
import logo from '../../assets/images/site-logo.png';
import { logout } from "../../actions/auth";
import icon_whatsapp from '../../assets/images/icon_whatsapp.svg';
import PrescriptionModal from './PrescriptionModal';
import { useDispatch } from "react-redux";
import useAxiosInstance from '../../Api/AxiosInstance';
import BookSurgury from "../pages/BookSurgury";

function DashboardHeader() {
    const dispatch = useDispatch();
    let navigate = useNavigate();
    // `items`/`setItems` are commented out with the cart-count request and the
    // hidden cart icon. Restore them together with the markup further down.
    // const [items, setItems] = useState()
    const [messages, setMessages] = useState()
    const AxiosInstance = useAxiosInstance()


    const user = JSON.parse(localStorage.getItem("user"));
    const handleLogout = (e) => {
        dispatch(logout());
        navigate("/");
    }

    /* -------------------------------------------------------------------------
       DUPLICATE cart-lists REQUEST (removed)
       This header used to POST 'cart-lists' on every page just to fill the
       {items} badge on the top-right cart icon. That icon is now commented out
       (see the markup below), and {items} appears ONLY inside that commented
       block - there is no live consumer of this response, and the request had no
       other side effect. It also duplicated work: on /shop the page's own
       fetchCart() had already asked for the same data.

       fetchDataMessage() (the notifications badge, which IS still rendered) is
       untouched, the itemAddedToCart listener is left in place so behaviour does
       not change, and the ShopPage cart is unaffected.

       PREVIOUS (kept for restore - uncomment together with the cart icon):
       const fetchData = async () => {
           try {
               const response = await AxiosInstance.post('cart-lists')
               setItems(response.data.data.length);
           } catch (error) {
           }
       }
    ------------------------------------------------------------------------- */
    const fetchDataMessage = async () => {

        try {
            const responseNotification = await AxiosInstance.post( 'get-count-notifications')
            setMessages(responseNotification.data.data.notifications.length);
        } catch (error) {

        }
    }

    /* The cart-count effect that lived here is removed along with fetchData() -
       see the note above. PREVIOUS (kept for restore):
       useEffect(() => {
           fetchData();
           document.addEventListener('itemAddedToCart', fetchData);
           return () => {
               document.removeEventListener('itemAddedToCart', fetchData);
           };
       }, [fetchData])
    */
    useEffect(() => {
        fetchDataMessage();
    }, [ fetchDataMessage])

    return (
        <>
            <header className='header dashboard-header'>
                <div className='dash-header-inner d-flex v-center'>

                    <div className='site-logo dashboard-logo d-flex v-center h-100'>
                        <Navbar.Brand>
                            <Link to='/dashboard'><img src={logo} alt='' /></Link>
                        </Navbar.Brand>
                    </div>

                    <div className='dash-head-right d-flex v-center'>
                        <div className='head-title-box'>
                            <h4 className='mb-0'><Link to='/dashboard'>My Dashboard</Link></h4>
                        </div>

                        <div className='dash-head-right-inn ml-auto d-flex v-center'>
                            <div className='dash-head-right-btnbox'>

                            </div>

                            <div className='dash-head-iconbox d-flex v-center'>

                                {/* ---------------------------------------------------------------
                                    HIDDEN AS REQUESTED: header cart icon. The cart now lives
                                    on the shop page, so this link is removed from view and is
                                    not clickable. Code kept for easy restore - uncomment this
                                    block to bring the icon back.

                                    To restore this icon you must also restore the cart
                                    request above: the `items` state and `fetchData()` were
                                    removed because this block was their only consumer
                                    (see the note near the top of the component).
                                    The itemAddedToCart listener was removed with it - the
                                    shop page runs its own listener for its cart panel.
                                ---------------------------------------------------------------- */}
                                {/*
                                <Link className='head-icon-link' to='/cart/'>
                                    <i className='fa fa-shopping-cart'></i>
                                    <span className='cart-count'>{items}</span>
                                </Link>
                                */}
                                <Link className='head-icon-link whatsapp_icon'
                                    // to='whatsapp://send?phone=91-9824928965'
                                    to='/notifications'
                                    target='_blank'>
                                    <i class="fa fa-bell"></i>
                                    <span className='cart-count'>{messages}</span>
                                </Link>
                                <Dropdown className='head-profile'>
                                    <Dropdown.Toggle className='profile-link d-flex v-center' id="dropdown-profile">
                                        <span className='head-icon-link'><img src={user?.user?.image_url} alt='' /></span>
                                        <strong className='profile-name'>{user?.user?.full_name}</strong>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item href="/my-profile">My Profile</Dropdown.Item>
                                        <Dropdown.Item href="/edit-profile">Edit Profile</Dropdown.Item>
                                        <Dropdown.Item href="/change-password">Change Password</Dropdown.Item>
                                        <Dropdown.Item onClick={() => handleLogout()} >Log Out</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}

export default DashboardHeader